export const PORTFOLIO_API_BASE_URL = 'https://api.patara.app/portfolio';
